export default "__VITE_ASSET__DVpAut2___"